import React, { useState, useRef } from "react";
import { Typography, Box, Card } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useAppStore } from "../appStore";
import axios from "axios";
import Sidenav from "../components/Sidenav";
import Navbar from "../components/Navbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Checkbox from "@mui/material/Checkbox";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function AddPatient() {
    const [userId, setUserId] = useState("");
    const [gender, setGender] = useState("");
    const [age, setAge] = useState("");
    const [country, setCountry] = useState("");
    const [occupation, setOccupation] = useState("");
    const [address, setAddress] = useState("");
    const [mobile, setMobile] = useState("");
    const [type, setType] = useState("Active");
    const [status, setStatus] = useState("Published");
    const [description, setDescription] = useState("");
    const [healerId, setHealerId] = useState("");
    const [symptomId, setSymptomId] = useState("");
    const [anyAddiction, setAnyAddiction] = useState("");
    const baseURL = process.env.REACT_APP_API_URL;
    const editor = useRef(null);
    const navigate = useNavigate();
    const token = useAppStore((state) => state.token);
    const yourpatients = useAppStore((state) => state.yourpatients);
    const healers = useAppStore((state) => state.healers);
    const categories = useAppStore((state) => state.categories);
    const [rowdata, setRowdata] = useState([]);

    const createUser = async (url) => {
        let posturl = baseURL + "patient";
        const tid = toast.loading("Please wait...");

        await axios
            .post(
                posturl,
                {
                    user_id: userId,
                    gender: gender,
                    age: age,
                    country: country,
                    occupation: occupation,
                    address: address,
                    mobile: mobile,
                    type: type,
                    status: status,
                    description: description,
                    any_addictions: anyAddiction,
                    healer_id: healerId,
                    symptom_id: symptomId,
                    tags: rowdata,
                },
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Content-type": "Application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            .then(function (res) {
                toast.update(tid, {
                    render: "Created!",
                    type: "success",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    isLoading: false,
                });
                navigate("/patient");
            })
            .catch(function (error) {
                toast.update(tid, {
                    render: error,
                    type: "error",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    isLoading: false,
                    theme: "light",
                });
                console.log("kcheckpost" + error); //return 429
            });
    };

    const handleNameChange = (event) => {
        setUserId(event.target.value);
    };

    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };

    const handleAgeChange = (event) => {
        setAge(event.target.value);
    };

    const handleCountryChange = (event) => {
        setCountry(event.target.value);
    };

    const handleOccupationChange = (event) => {
        setOccupation(event.target.value);
    };

    const handleAddressChange = (event) => {
        setAddress(event.target.value);
    };

    const handleMobileChange = (event) => {
        setMobile(event.target.value);
    };

    const handleTypeChange = (event) => {
        setType(event.target.value);
    };

    const handleStatusChange = (event) => {
        setStatus(event.target.value);
    };

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
    };

    const handleHealerIdChange = (event) => {
        setHealerId(event.target.value);
    };

    const handleSymptomIdChange = (event) => {
        setSymptomId(event.target.value);
    };

    const handleAnyAddictionChange = (event) => {
        setAnyAddiction(event.target.value);
    };

    const handleTagChange = (v) => {
        setRowdata(v);
    };

    return (
        <>
            <ToastContainer />
            <div className="bgcolor">
                <Navbar />
                <Box height={70} />
                <Box sx={{ display: "flex" }}>
                    <Sidenav />
                    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                        <Card
                            sx={{
                                width: "98%",
                                overflow: "hidden",
                                padding: "12px",
                            }}
                        >
                            <Typography variant="h5" align="center">
                                Add Patient
                            </Typography>
                            <Box height={10} />
                            <IconButton
                                style={{
                                    position: "absolute",
                                    top: "-10",
                                    left: "20",
                                }}
                                onClick={() => {
                                    navigate("/patient");
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                            <Box height={20} />
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <FormControl
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            minWidth: "100%",
                                            marginTop: "30px",
                                        }}
                                    >
                                        <InputLabel id="demo-simple-select-standard-label">
                                            Patient
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={userId}
                                            onBlur={handleNameChange}
                                            onChange={handleNameChange}
                                            label="Name"
                                        >
                                            {yourpatients.map((item, index) => {
                                                return (
                                                    <MenuItem
                                                        value={item.id}
                                                        key={index}
                                                    >
                                                        {item.email}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            marginTop: "30px",
                                            minWidth: "100%",
                                        }}
                                    >
                                        <InputLabel id="label-qualification">
                                            Gender
                                        </InputLabel>
                                        <Select
                                            labelId="label-qualification"
                                            value={gender}
                                            onChange={handleGenderChange}
                                            onBlur={handleGenderChange}
                                            label="gender"
                                        >
                                            <MenuItem value={"Female"}>
                                                Female
                                            </MenuItem>
                                            <MenuItem value={"Male"}>
                                                Male
                                            </MenuItem>
                                            <MenuItem value={"Other"}>
                                                Other
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        value={age}
                                        onChange={handleAgeChange}
                                        label="Age"
                                        type="number"
                                        size="small"
                                        sx={{
                                            marginTop: "30px",
                                            minWidth: "100%",
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        value={anyAddiction}
                                        onChange={handleAnyAddictionChange}
                                        label="Any Addiction"
                                        type="text"
                                        size="small"
                                        sx={{
                                            minWidth: "100%",
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            minWidth: "100%",
                                        }}
                                    >
                                        <InputLabel id="demo-simple-select-standard-label">
                                            Healer
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={healerId}
                                            onBlur={handleHealerIdChange}
                                            onChange={handleHealerIdChange}
                                            label="User Type"
                                        >
                                            {healers.map((item, index) => {
                                                return (
                                                    <MenuItem
                                                        value={item.id}
                                                        key={index}
                                                    >
                                                        {item.email}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        value={mobile}
                                        onChange={handleMobileChange}
                                        label="Mobile"
                                        type="text"
                                        size="small"
                                        sx={{
                                            minWidth: "100%",
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        value={occupation}
                                        onChange={handleOccupationChange}
                                        label="Occupation"
                                        type="text"
                                        size="small"
                                        sx={{
                                            minWidth: "100%",
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        value={type}
                                        onChange={handleTypeChange}
                                        label="Type"
                                        type="text"
                                        size="small"
                                        sx={{
                                            minWidth: "100%",
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        value={status}
                                        onChange={handleStatusChange}
                                        label="Status"
                                        type="text"
                                        size="small"
                                        sx={{
                                            minWidth: "100%",
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <TextField
                                        value={country}
                                        onChange={handleCountryChange}
                                        label="Country"
                                        type="text"
                                        size="small"
                                        sx={{
                                            minWidth: "100%",
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        value={address}
                                        onChange={handleAddressChange}
                                        label="Address"
                                        type="text"
                                        size="small"
                                        sx={{
                                            minWidth: "100%",
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Autocomplete
                                        multiple
                                        id="checkboxes-tags-demo"
                                        options={categories}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.name}
                                        onChange={(e, v) => handleTagChange(v)}
                                        renderOption={(
                                            props,
                                            option,
                                            { selected }
                                        ) => (
                                            <li {...props}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.name}
                                            </li>
                                        )}
                                        size="small"
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                size="small"
                                                label="Symptoms"
                                                placeholder="Symptoms"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        error={false}
                                        id="description"
                                        name="description"
                                        value={description}
                                        onChange={handleDescriptionChange}
                                        label="Description"
                                        size="small"
                                        sx={{
                                            marginTop: "0px",
                                            minWidth: "100%",
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h5" align="center">
                                        <Button
                                            variant="contained"
                                            onClick={createUser}
                                        >
                                            Submit
                                        </Button>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Card>
                    </Box>
                </Box>
            </div>
        </>
    );
}
